import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestBikeStatuses = () =>
  axios.get(`${apiUrl}bike/statuses`);

export const requestBikeListNoPagination = (criteria = []) =>
  axios.post(`${apiUrl}bike/list`, {
    criteria
  });

export const requestUpdateBikeStatus = (bikeId, status) =>
  axios.patch(`${apiUrl}bike/${bikeId}/${status}`);

export const requestUpdateBike = (bike) =>
  axios.put(`${apiUrl}bike/${bike.id}`, bike);

export const requestGetAlerts = () => axios.get(`${apiUrl}bike/alert`);

export const requestGetAlertTypes = () => axios.get(`${apiUrl}bike/alert/types`);



// WEBPACK FOOTER //
// ./src/actions/bike/requests.js